// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface AdminUser {
  id: number;
  login: string;
  lastname: string | null;
  firstname: string | null;
  email: string | null;
  access: string;
  td_group: string | null;
  can_be_solo: boolean;
  is_local: boolean;
  registration_completed_at: string | null;
  project_group: any;
}

export interface ImportRow {
  lastname: string;
  firstname: string;
  email: string;
  td_group: string;
  login: string | null;
  status: string;
  message: string;
}

interface ActionResponse {
  message: string;
  [key: string]: any;
}

async function callApi(path: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', accessToken: string, body?: any): Promise<any> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(json.message || `HTTP error! status: ${response.status}`);
  }

  return json;
}

class UserAdminService {

  async listUsers(accessToken: string): Promise<AdminUser[]> {
    const json = await callApi('/users', 'GET', accessToken);
    return json.data;
  }

  async deleteUser(userId: number, accessToken: string): Promise<ActionResponse> {
    return callApi(`/users/${userId}`, 'DELETE', accessToken);
  }

  async createUser(data: { login: string; access: string; lastname?: string; firstname?: string; email?: string; td_group?: string; is_local?: boolean; password?: string }, accessToken: string): Promise<ActionResponse> {
    return callApi('/admin/users', 'POST', accessToken, data);
  }

  async updateUser(userId: number, data: { login?: string; access?: string; email?: string | null; lastname?: string | null; firstname?: string | null; td_group?: string | null; can_be_solo?: boolean; is_local?: boolean; password?: string }, accessToken: string): Promise<ActionResponse> {
    return callApi(`/admin/users/${userId}`, 'PUT', accessToken, data);
  }

  async importStudents(file: File, apply: boolean, accessToken: string): Promise<{ message: string; rows: ImportRow[]; apply: boolean }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('apply', apply ? 'true' : 'false');

    const response = await fetch(`${API_BASE_URL}/admin/users/import-students`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      },
      body: formData,
    });

    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }
    return json;
  }
}

export const userAdminService = new UserAdminService();
